import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { ArtTreatmentDefinition, ArtTreatmentIndication, ArtTreatmentIntegrity } from '../../../models';
import { ArtTreatmentTranslatePipe } from '@shared/pipes/art-treatment-translate.pipe';

@Component({
	selector: 'rx-intuitive-art-indication-button',
	templateUrl: './rx-intuitive-art-indication-button.component.html',
	styleUrls: ['./rx-intuitive-art-indication-button.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TlkButtonComponent, ArtTreatmentTranslatePipe, NgIf]
})
export class RxIntuitiveArtIndicationButtonComponent {
	@Input() indication!: ArtTreatmentIndication;
	@Input() disabled = false;
	@Input() isActive = false;
	@Input() asLabel = false;
	@Input() hideIcon = false;

	@Output() readonly clicked = new EventEmitter<ArtTreatmentIndication>();

	onClicked(): void {
		if (!this.disabled) {
			this.clicked.emit(this.indication);
		}
	}

	get indicationClass(): string {
		return ArtTreatmentIntegrity[this.indication] ?? ArtTreatmentDefinition[this.indication] ?? 'default';
	}
}
